
import { useBlobImage } from "../service/Hooks/useBlobImage";

const DomainLogo = ({ 
  blobName, 
  domainName,
  size = 60, 
  className = "",
  showFallback = true 
}) => {
  const { imageUrl, loading, error } = useBlobImage(blobName, "domains");

  // Style pour le conteneur
  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    minWidth: `${size}px`,
  };

  // Fallback si pas d'image
  const renderFallback = () => (
    <div 
      className="d-flex align-items-center justify-content-center bg-light border rounded-circle"
      style={containerStyle}
    >
      <span 
        className="fw-bold text-primary"
        style={{ fontSize: size * 0.3 }}
      >
        {domainName ? domainName.charAt(0).toUpperCase() : 'D'}
      </span>
    </div>
  );

  if (loading) {
    return (
      <div 
        className={`placeholder-glow ${className}`}
        style={containerStyle}
      >
        <div 
          className="placeholder rounded-circle bg-secondary"
          style={containerStyle}
        ></div>
      </div>
    );
  }

  if (error || !imageUrl) {
    return showFallback ? renderFallback() : null;
  }

  return (
    <div 
      className={`rounded-circle border shadow-sm overflow-hidden ${className}`}
      style={{
        ...containerStyle,
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '';
      }}
    >
      <img
        src={imageUrl}
        alt={domainName ? `Logo ${domainName}` : 'Logo domaine'}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
        onError={(e) => {
          console.error("Erreur de chargement de l'image:", blobName);
          if (showFallback) {
            e.target.style.display = 'none';
          }
        }}
      />
    </div>
  );
};

export default DomainLogo;